 <template>
  <v-dialog v-model="dialog" :max-width="!next ? 800 : 520" persistent>
    <v-card class="pt-2 pl-0 pr-0">
      <v-card-title
        class="headline-6"
        :class="{ 'subtitle-2': $vuetify.breakpoint.xs }"
        style="word-break: normal; !important"
      >
        {{ $vuetify.lang.t("$vuetify.EDICAO_LOTE") }}
      </v-card-title>

      <v-form
        ref="form"
        lazy-validation
        class="overflow-y-hidden overflow-x-hidden"
      >
        <v-list class="ma-0 pa-0" max-height="430" min-height="430">
          <v-row v-if="next" class="ma-0 d-flex justify-center mb-n3 pt-4 ml-12">
            <v-col cols="12" class="ml-12 mt-n6">
              <v-row class="ml-1">
                <v-col cols="9" class="mt-0 pr-0 mr-0">
                  <v-row>
                    <span
                      class="
                        text-right
                        subtitle-2
                        font-weight-bold
                        grey--text
                        text--lighten-1
                      "
                    >
                      {{ $vuetify.lang.t("$vuetify.BUSCAR") }}:</span
                    >
                  </v-row>
                  <v-row class="mr-1">
                    <v-text-field
                      v-model.trim="searchPermissionText"
                      dense
                      label="Regular"
                      :placeholder="$vuetify.lang.t('$vuetify.NOME_PERMISSAO')"
                      single-line
                      solo
                      append-icon="mdi-magnify"
                      @click:append="searchPermissions()"
                      @keypress.enter.stop.prevent="searchPermissions()"
                    ></v-text-field>
                  </v-row>
                </v-col>
              </v-row>

              <v-row class="mt-n3">
                <v-col class="ml-n5" cols="10">
                  <v-lazy
                    :options="{ threshold: 0.6 }"
                    transition="slide-x-transition"
                  >
                    <v-list
                      v-show="permissions.length > 0"
                      two-line
                      flat
                      class="ml-0 mt-n5 pt-3 overflow-y-auto"
                    >
                      <v-list-item-group multiple>
                        <v-virtual-scroll
                          bench="0"
                          :items="permissions"
                          item-height="44"
                          class="ml-3 mt-0 overflow-y-auto"
                          :height="$vuetify.breakpoint.xs ? 170 : 260"
                        >
                          <template v-slot:default="{ item }">
                            <v-list-item
                              class="mt-n0"
                              :class="{ 'ml-n3': $vuetify.breakpoint.xs }"
                            >
                              <template v-slot:default="{}">
                                <v-list-item-action>
                                  <v-checkbox
                                    v-model="selectedPermissions"
                                    color="blue darken-2"
                                    dense
                                    :value="item"
                                  ></v-checkbox>
                                </v-list-item-action>

                                <v-list-item-content
                                  class="ml-n3"
                                  :class="{ 'ml-n7': $vuetify.breakpoint.xs }"
                                >
                                  <v-list-item-title
                                    class="subtitle-2"
                                    :class="{ caption: $vuetify.breakpoint.xs }"
                                  >
                                    {{ item.nome }}</v-list-item-title
                                  >
                                </v-list-item-content>
                              </template>
                            </v-list-item>
                          </template>
                        </v-virtual-scroll>
                      </v-list-item-group>
                    </v-list>
                  </v-lazy>

                  <v-lazy
                    :options="{ threshold: 0.6 }"
                    transition="slide-x-transition"
                  >
                    <WarningPanel
                      class="ml-3 mt-8"
                      :mobile="true"
                      :message="
                        $vuetify.lang.t(
                          '$vuetify.NENHUMA_PERMISSAO_SELECIONADA'
                        )
                      "
                      v-show="permissions.length == 0 && !isLoadingPermissions"
                      :small="true"
                    ></WarningPanel>
                  </v-lazy>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-progress-circular
                  v-if="isLoadingPermissions"
                  :size="30"
                  :width="4"
                  color="blue darken-2"
                  indeterminate
                  class="ml-n10 mt-6 mb-n1 text-center"
                ></v-progress-circular>
              </v-row>
            </v-col>
          </v-row>

          <v-row
            v-if="!next"
            class="ma-0 d-flex justify-center mb-n3 pt-4 ml-4"
          >
            <v-col>
              <v-row>
                <v-col cols="5" class="ml-9 mt-n4 pr-0 mr-0">
                  <v-row>
                    <span
                      class="
                        text-right
                        subtitle-2
                        font-weight-bold
                        grey--text
                        text--lighten-1
                      "
                    >
                      {{ $vuetify.lang.t("$vuetify.BUSCAR") }}:</span
                    >
                  </v-row>
                  <v-row class="mr-1">
                    <v-text-field
                      v-model.trim="searchText"
                      dense
                      label="Regular"
                      :placeholder="$vuetify.lang.t('$vuetify.NOME_CAMPO')"
                      single-line
                      solo
                      append-icon="mdi-magnify"
                      @click:append="
                        searchFields();
                        selectedCheckList = [];
                        active = false;
                      "
                      @keypress.enter.stop.prevent="
                        searchFields();
                        selectedCheckList = [];
                        active = false;
                      "
                      :rules="[
                        (v) =>
                          v.length >= 3 ||
                          $vuetify.lang.t('$vuetify.MIN_CARACTERES', 3),
                      ]"
                    ></v-text-field>
                  </v-row>
                </v-col>
              </v-row>

              <v-row class="mt-n4">
                <v-col class="ml-1">
                  <v-checkbox
                    :input-value="active"
                    v-model="active"
                    color="blue darken-2"
                    dense
                    :value="active"
                    @click.native="selectDeselectAll(active)"
                    class="ml-7"
                    :label="$vuetify.lang.t('$vuetify.SELECIONAR_TODOS')"
                    v-show="fields.length > 0"
                  ></v-checkbox>

                  <v-lazy
                    :options="{ threshold: 0.6 }"
                    transition="slide-x-transition"
                  >
                    <v-list
                      v-show="fields.length > 0"
                      two-line
                      flat
                      class="ml-0 mt-n6 pt-3 overflow-y-auto"
                    >
                      <v-list-item-group multiple>
                        <v-virtual-scroll
                          bench="0"
                          :items="fields"
                          item-height="46"
                          class="ml-3 mt-0 overflow-y-auto"
                          height="270"
                        >
                          <template v-slot:default="{ item }">
                            <v-list-item
                              class="mt-n0"
                              :class="{ 'ml-n3': $vuetify.breakpoint.xs }"
                            >
                              <template v-slot:default="{ active }">
                                <v-list-item-action>
                                  <v-checkbox
                                    v-model="selectedCheckList"
                                    color="blue darken-2"
                                    dense
                                    :value="item"
                                    @click.native="
                                      selectItem(item, true, active)
                                    "
                                  ></v-checkbox>
                                </v-list-item-action>

                                <v-list-item-content
                                  class="ml-n3"
                                  :class="{ 'ml-n7': $vuetify.breakpoint.xs }"
                                >
                                  <v-list-item-title
                                    class="subtitle-2"
                                    :class="{ caption: $vuetify.breakpoint.xs }"
                                  >
                                    {{ item.nome }}</v-list-item-title
                                  >
                                </v-list-item-content>
                              </template>
                            </v-list-item>
                          </template>
                        </v-virtual-scroll>
                      </v-list-item-group>
                    </v-list>
                  </v-lazy>

                  <v-lazy
                    :options="{ threshold: 0.6 }"
                    transition="slide-x-transition"
                  >
                    <WarningPanel
                      class="mt-9 pt-12"
                      :mobile="true"
                      :message="$vuetify.lang.t('$vuetify.' + noEntityMassage)"
                      v-show="fields.length == 0 && !loading"
                      :small="true"
                    ></WarningPanel>
                  </v-lazy>

                  <v-row justify="center">
                    <v-progress-circular
                      v-if="loading"
                      :size="30"
                      :width="4"
                      color="blue darken-2"
                      indeterminate
                      class="ml-n2 mt-6 mb-n1 text-center"
                    ></v-progress-circular>
                  </v-row>
                </v-col>

                <v-divider
                  vertical
                  class="mt-8 mb-8"
                  :style="{ height: 15 + 'em' }"
                >
                </v-divider>

                <v-col
                  class="overflow-y-auto overflow-x-hidden mt-8 mr-6"
                  :style="{ height: 15 + 'em' }"
                >
                  <v-col
                    cols="11"
                    class="ml-4 mt-n8"
                    :class="{ 'mt-n8': $vuetify.breakpoint.xs }"
                  >
                    <WarningPanel
                      class="mt-6 pt-12 ml-n0"
                      :mobile="true"
                      :message="
                        $vuetify.lang.t('$vuetify.' + noSelectedMessage)
                      "
                      v-show="selectedItemList.length == 0"
                      :small="true"
                    >
                    </WarningPanel>

                    <v-row
                      class="ml-0 mt-2 d-flex justify-center"
                      :class="{ 'ml-n7': $vuetify.breakpoint.xs }"
                      v-for="item in selectedItemList"
                      :key="item.id"
                    >
                      <v-lazy
                        :options="{ threshold: 0.6 }"
                        transition="slide-x-transition"
                      >
                        <v-chip
                          :key="item.id + 1"
                          color="blue darken-2"
                          class="ml-0 mr-2 mt-2"
                          :class="{ 'ml-2': $vuetify.breakpoint.xs }"
                          label
                          :small="$vuetify.breakpoint.xs"
                          @click:close="selectItem(item, false)"
                          close
                          :id="item.nome"
                        >
                          {{ item.nome }}
                        </v-chip>
                      </v-lazy>
                    </v-row>
                  </v-col>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-list>
      </v-form>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-2"
          text
          @click="
            $refs.form.resetValidation();
            $refs.form.reset();
            close();
            cleanFields();
          "
        >
          {{ $vuetify.lang.t("$vuetify.CANCELAR") }}
        </v-btn>

        <v-btn v-if="!next" color="blue darken-2" text @click="next = true">
          {{ $vuetify.lang.t("$vuetify.PROXIMO") }}
        </v-btn>

        <v-btn v-if="next" color="blue darken-2" text @click="next = false">
          {{ $vuetify.lang.t("$vuetify.ANTERIOR") }}
        </v-btn>

        <v-btn
          v-if="next"
          color="blue darken-2"
          text
          @click="
            $refs.form.validate();
            send(selectedItemList, selectedPermissions);
          "
          :loading="isLoading"
        >
          {{ $vuetify.lang.t("$vuetify.ENVIAR") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import WarningPanel from "../../components/panels/WarningPanel";

export default {
  components: {
    WarningPanel,
  },
  props: {
    close: Function,
    dialog: Boolean,
    color: String,
    send: Function,
    isLoading: Boolean,
    noEntityMassage: String,
    noSelectedMessage: String,
    url: String,
  },
  methods: {
    selectDeselectAll(active) {
      
      this.selectedCheckList = [];
      var vm = this;

      if (active) {
        
        this.fields.forEach(function (item, i) {
          vm.selectedCheckList.push(vm.fields[i]);

          var sItem = vm.selectedItemList.filter(obj => obj.id == item.id)
          if(!sItem || sItem.length == 0){
            vm.selectedItemList.push(vm.fields[i])
          }
        });

      }else{
        
        this.fields.forEach(function (item) {

          vm.selectedItemList = vm.selectedItemList.filter(obj => obj.id != item.id)

        });

      }
    },
    searchPermissions() {
      this.permissions = [];
      this.isLoadingPermissions = true;

      this.$get("/permissao/busca", {
        searchText: this.searchPermissionText,
      }).then((response) => {
        if (response && response.data.length == 0) {
          this.noResult = true;
        }

        this.permissions = this.permissions.concat(response.data);
        this.isLoadingPermissions = false;
      });
    },
    searchFields() {
      if (this.searchText.length < 3) {
        return;
      }

      this.loading = true;
      this.fields = [];

      this.$get(this.url, {
        searchText: this.searchText,
        tipoServico: this.selectedType == "TODOS" ? "" : this.selectedType,
      }).then((response) => {
        this.fields = response.data;
        this.loading = false;
      });
    },
    selectItem(item, checkList) {
      if (
        !this.containsItem(item, this.selectedItemList) &&
        this.containsItem(item, this.selectedCheckList)
      ) {
        this.selectedItemList.push(item);
      } else {
        if (!checkList || !this.containsItem(item, this.selectedCheckList))
          this.selectedItemList = this.selectedItemList.filter(function (
            value
          ) {
            return value.id != item.id;
          });

        if (!checkList)
          this.selectedCheckList = this.selectedCheckList.filter(function (
            value
          ) {
            return value.id != item.id;
          });
      }
    },
    containsItem(item, list) {
      for (var index in list) {
        if (list[index].id == item.id) {
          return true;
        }
      }

      return false;
    },
    cleanFields() {
      this.fields = [];
      this.permissions = [];
      this.selectedPermissions = [];
      this.selectedItemList = [];
      this.selectedCheckList = [];
      this.searchText = "";
      this.searchPermissionText = "";
      this.active = false;
      this.next = false;
    },
  },
  data() {
    return {
      loading: false,
      fields: [],
      check: false,
      searchText: "",
      searchPermissionText:"",
      selectedItemList: [],
      selectedCheckList: [],
      permissions: [],
      selectedPermissions: [],
      isLoadingPermissions: false,
      active: false,
      next: false,
      rules: [
        (v) =>
          (v && v.length >= 1) ||
          this.$vuetify.lang.t("$vuetify.CAMPO_OBRIGATORIO"),
      ],
    };
  },
  created: function () {
    this.$root.$on("invalidateFields", () => {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.cleanFields();
    });
  },
};
</script>